<template>
    <div clas="home">
      <div class="container t-c">
          <div class="box" :class="category">
            <span class="head">
              <img src="img/headrest.gif">
            </span>
            <h1 class="title">{{text}}</h1>
            <span v-for="(v,k) in answers" :key="k">
              <a v-if="v.TYPE === 'link'" :href="v.NEXT" class="btn btn-secondary" target="_blank">{{v.TEXT}}</a>
              <span v-if="v.TYPE === 'multi'" @click="goTo(v.NEXT)" class="btn btn-multiple">{{v.TEXT}}</span>
              <span v-if="v.TYPE === 'btn'" class="btn btn-secondary" @click="goTo(v.NEXT)">{{v.TEXT}}</span>
            </span>
          </div>
      </div>
      <Footer></Footer>
    </div>
</template>

<style lang="scss">
$size: 7rem;

.head {
  background: #e8e8e8;
  border-radius: 50%;
  display: inline-block;
  height: $size;
  margin-top: -($size / 1.5);
  padding: 1rem;
  width: $size;
  img {
    height: 90%;
    margin-top: 0.5rem;
  }
}
</style>


<script>
import Footer from "@/components/modules/footer.vue";
import {questions} from "@/components/data/Questions.js"

export default {
  name: "Home",
  components: {
    Footer
  },
  data: function () {
    return {
      questions: questions,
      id: '1',
      answers: [],
      text: '',
      category: '',
      textAwnser: '',
      next: '',
      type: '',
    }
  },
  mounted () {
    this.loadQuestions()
  },
  methods: {
    loadQuestions () {
      this.questions.map(p => {
        const id = p['ID']
        if (id === this.id) {
          this.answers = p['ANSWERS']
          this.category = p['CATEGORY']
          this.text = p['TEXT']
        }
      })
    },
    loadAnswers () {
      this.answers.map(p => {
        this.textAwnser = p['TEXT']
        this.next = p['NEXT']
        this.type = p['TYPE']
      })
    },
    goTo (id) {
      console.log(id)
      this.id = id
      this.loadQuestions()
    }
  }
}
</script>
